import { code } from "@spscommerce/utils";

export const SpsMultiSelectTagExamples = {
    basic: {
        label: "Basic",
        description:
            "<p>Info about basic multi select tag</p>",
        examples: {
            basic: {
                template: code`
                    <sps-multi-select-tag kind="blue" (remove)="onRemove()">Ankle Strap</sps-multi-select-tag>
                    <sps-multi-select-tag kind="red" (remove)="onRemove()">Ankle Strap</sps-multi-select-tag>
                    <sps-multi-select-tag kind="gray" (add)="onAdd()">Ankle Strap</sps-multi-select-tag>
                `,
                class: code`
                    class DemoComponent {
                        onRemove() {
                            console.log("REMOVED");
                        }
                        onAdd() {
                            console.log("ADDED");
                        }
                    }
                `
            }
        }
    }
};
